export default __webpack_public_path__ + "static/media/wolf_head.dd9990dc.gif";